import React, {useState} from "react";
import {Card} from "react-bootstrap";
import {PiCaretDown, PiCaretUp, PiInfo} from "react-icons/pi";

const TEXT =
    "Diese Seite schätzt, wie viel Umsatz zusätzlich möglich gewesen wäre, wenn jeder Farbton im gewählten " +
    "Zeitraum durchgehend lieferbar gewesen wäre - eine eigene, einzeln vergebbare Auswertung, unabhängig vom " +
    "übrigen Bereich Cosmos (Freigabe 22.09.2026).";

const STORAGE_KEY = "eu-zweck-box-open";

function gespeichertOffen() {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
        return false;
    }
}

function speichereOffen(offen) {
    try {
        window.localStorage.setItem(STORAGE_KEY, offen ? "1" : "0");
    } catch (e) {
        // localStorage nicht verfügbar - Aufklappzustand gilt dann nur für die laufende Sitzung.
    }
}

/** Zweckkasten oben auf der Seite, nach dem Vorbild von SalesAnalysis/PurposeBox.jsx. */
export default function ZweckKasten() {
    const [offen, setOffen] = useState(gespeichertOffen);

    const umschalten = () => {
        setOffen((aktuell) => {
            const naechsterWert = !aktuell;
            speichereOffen(naechsterWert);
            return naechsterWert;
        });
    };

    return (
        <Card className="mb-3 border-0 bg-body-secondary">
            <button
                type="button"
                className="btn btn-link text-decoration-none text-body d-flex align-items-center gap-2 w-100 text-start px-3 py-2"
                aria-expanded={offen}
                onClick={umschalten}
            >
                <PiInfo className="flex-shrink-0" aria-hidden="true" />
                <span className="fw-semibold small">Wozu diese Seite</span>
                <span className="ms-auto">{offen ? <PiCaretUp aria-hidden="true" /> : <PiCaretDown aria-hidden="true" />}</span>
            </button>
            {offen && <Card.Body className="pt-0 small text-muted">{TEXT}</Card.Body>}
        </Card>
    );
}
